export default __webpack_public_path__ + "static/media/college-project.941913c8.jpg";